/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Ordinamento scolastico (dominio MIUR)
 */
export enum OrdinamentoScolastico {

    INFANZIA = 'INFANZIA',

    PRIMARIA = 'PRIMARIA',

    SECONDARIA_PRIMO_GRADO = 'SECONDARIA_PRIMO_GRADO',

    SECONDARIA_SECONDO_GRADO = 'SECONDARIA_SECONDO_GRADO',

    IFP = 'IFP',

    ITS_ACADEMY = 'ITS_ACADEMY',

    CPIA = 'CPIA'
}

